import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import App from './App'
import './i18n'
import './styles/index.css'

import { ThemeProvider } from './contexts/ThemeContext'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <App />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 5000,
            style: {
              background: 'var(--bg-secondary)',
              color: 'var(--text-primary)',
              borderRadius: 'var(--border-radius)',
              border: '1px solid var(--border-color)',
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: 'var(--success-500)',
                secondary: 'white',
              },
            },
            error: {
              duration: 6000,
              iconTheme: {
                primary: 'var(--error-500)',
                secondary: 'white',
              },
            },
          }}
        />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
)
import './styles/components.css'
